/*export const telegramTypeId = 1
export const bragTypeId = 2
export const discussionTypeId = 3
export const reviewTypeId = 4*/
export const notesTypeId = 5
export const salesTypeId = 6
export const promocodeTypeId = 7
export const offersTypeId = 8
export const freeTypeId = 9
export const foodAndProductsTypeId = 10
export const banksTypeId = 12
export const gamesTypeId = 13
export const raffleTypeId = 14
export const articlesTypeId = 15

/*
export const travelsTypeId = 11
*/
